export const manifest = {
  screens: {
    scr_xddjif: { name: "Home", route: "/", position: {"x":160,"y":220} },
    scr_ghb78q: { name: "Purchase · Borrower Info", route: "/purchase", state: {"currentStep":0}, position: {"x":160,"y":2200} },
    scr_6zs20o: { name: "Purchase · Employment & Income", route: "/purchase", state: {"currentStep":1}, position: {"x":1560,"y":2200} },
    scr_f7dmja: { name: "Purchase · Co-Borrower", route: "/purchase", state: {"currentStep":2}, position: {"x":2960,"y":2200} },
    scr_zlwg0q: { name: "Purchase · Subject Property", route: "/purchase", state: {"currentStep":3}, position: {"x":4360,"y":2200} },
    scr_o1kyja: { name: "Purchase · Purchase Details", route: "/purchase", state: {"currentStep":4}, position: {"x":5760,"y":2200} },
    scr_cm980h: { name: "Purchase · Housing Expenses", route: "/purchase", state: {"currentStep":5}, position: {"x":7160,"y":2200} },
    scr_9bow5d: { name: "Purchase · Assets & Credit", route: "/purchase", state: {"currentStep":6}, position: {"x":8560,"y":2200} },
    scr_oacgl8: { name: "Purchase · Review", route: "/purchase", state: {"currentStep":7}, position: {"x":9960,"y":2200} },
    scr_0q7qn9: { name: "Refinance · Borrower Info", route: "/refinance", state: {"currentStep":0}, position: {"x":160,"y":4180} },
    scr_3hzs4x: { name: "Refinance · Employment & Income", route: "/refinance", state: {"currentStep":1}, position: {"x":1560,"y":4180} },
    scr_7vcnnz: { name: "Refinance · Co-Borrower", route: "/refinance", state: {"currentStep":2}, position: {"x":2960,"y":4180} },
    scr_b0navb: { name: "Refinance · Subject Property", route: "/refinance", state: {"currentStep":3}, position: {"x":4360,"y":4180} },
    scr_u72sai: { name: "Refinance · Current Mortgage", route: "/refinance", state: {"currentStep":4}, position: {"x":5760,"y":4180} },
    scr_bwl0s6: { name: "Refinance · Credit & Assets", route: "/refinance", state: {"currentStep":5}, position: {"x":7160,"y":4180} },
    scr_on8dm3: { name: "Refinance · Review", route: "/refinance", state: {"currentStep":6}, position: {"x":8560,"y":4180} },
  },
  sections: {
    sec_i6s0md: { name: "Home", x: 0, y: 0, width: 1520, height: 1180 },
    sec_wv9s1w: { name: "Purchase Application", x: 0, y: 1980, width: 11320, height: 1180 },
    sec_3ojxjc: { name: "Refinance Application", x: 0, y: 3960, width: 9920, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_i6s0md", children: [
      { kind: "screen", id: "scr_xddjif" },
    ] },
    { kind: "section", id: "sec_wv9s1w", children: [
      { kind: "screen", id: "scr_ghb78q" },
      { kind: "screen", id: "scr_6zs20o" },
      { kind: "screen", id: "scr_f7dmja" },
      { kind: "screen", id: "scr_zlwg0q" },
      { kind: "screen", id: "scr_o1kyja" },
      { kind: "screen", id: "scr_cm980h" },
      { kind: "screen", id: "scr_9bow5d" },
      { kind: "screen", id: "scr_oacgl8" },
    ] },
    { kind: "section", id: "sec_3ojxjc", children: [
      { kind: "screen", id: "scr_0q7qn9" },
      { kind: "screen", id: "scr_3hzs4x" },
      { kind: "screen", id: "scr_7vcnnz" },
      { kind: "screen", id: "scr_b0navb" },
      { kind: "screen", id: "scr_u72sai" },
      { kind: "screen", id: "scr_bwl0s6" },
      { kind: "screen", id: "scr_on8dm3" },
    ] },
  ],
}
